import { useMutation, UseMutationResult, useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { getSLAConfigMetaData, getSLAsByServiceId, refreshSLAsByServiceId, resetSLAById, resetSLAsByServiceId, updateSLATimeoutAt } from '../api/sla';
import { SLAConfigMetaDataKey, SLAsByServiceKey, SLATimeoutAtKey } from '../configs/sla';
import { SLAConfigMetaDataResponse } from '../@types';

export const useGetSLAsByServiceId = (serviceId: number): UseQueryResult<any> => {
  return useQuery({
    queryKey: [SLAsByServiceKey, serviceId],
    queryFn: () => getSLAsByServiceId(serviceId)
  });
};

export const useUpdateSLATimeoutAt = (): UseMutationResult => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      return await updateSLATimeoutAt(data.id, data);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [SLATimeoutAtKey]
      });
    }
  });
};

export const useResetSLAsByServiceId = (serviceId: number): UseMutationResult => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      return await resetSLAsByServiceId(serviceId);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [SLAsByServiceKey, serviceId]
      });
    }
  });
};

export const useResetSLAById = (serviceId: number): UseMutationResult => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: any) => {
      return await resetSLAById(data.slaId);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [SLAsByServiceKey, serviceId]
      });
    }
  });
};

export const useRefreshSLAsByServiceId = (serviceId: number): UseMutationResult => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      return await refreshSLAsByServiceId(serviceId);
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [SLAsByServiceKey, serviceId]
      });
    }
  });
};

export const useGetSLAConfigMetaData = (): UseQueryResult<SLAConfigMetaDataResponse> => {
  return useQuery({
    queryKey: [SLAConfigMetaDataKey],
    queryFn: () => getSLAConfigMetaData(),
    staleTime: 5 * 60 * 60 * 1000
  });
};